module.exports = __webpack_public_path__ + "img/bg.f174771c.jpg";